import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
export var InventoryAvailabilityStatus = {
    preOrder: 'preOrder',
    inStock: 'inStock',
    onItsWay: 'onItsWay',
};
var inventoryApi = createApi({
    reducerPath: 'inventoryApi',
    baseQuery: fetchBaseQuery(),
    endpoints: function (builder) { return ({
        getModelInventoryStatus: builder.query({
            query: function (_a) {
                var url = _a.url, headers = _a.headers, params = _a.params;
                return ({
                    url: url,
                    headers: headers,
                    params: params,
                });
            },
            // FIXME: temporary workaround to avoid cache issues. Requires investigation.
            keepUnusedDataFor: 10,
        }),
    }); },
});
export var inventoryApiReducer = inventoryApi.reducer;
export var inventoryApiMiddleware = inventoryApi.middleware;
export var useGetModelInventoryStatusQuery = inventoryApi.useGetModelInventoryStatusQuery;
export default inventoryApi;
